import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';

const STEPS = [
  {
    icon: <DescriptionRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Conte sobre seu perfil',
    description: 'Informe algumas informações sobre sua empresa e necessidades.',
  },
  {
    icon: <FactCheckRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Analisamos suas possibilidades',
    description: 'Nossa equipe avalia as opções disponíveis para o seu perfil.',
  },
  {
    icon: <AssignmentTurnedInRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Receba uma proposta personalizada',
    description: 'Você recebe opções para avaliar cobertura, rede e custo-benefício.',
  },
  {
    icon: <SupportAgentRoundedIcon sx={{ fontSize: 24 }} />,
    title: 'Conte com atendimento especializado',
    description: 'Nossa equipe acompanha você durante o processo.',
  },
];

const SolucaoSection: React.FC = () => {
  return (
    <Box
      id="como-funciona"
      component="section"
      sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.paper', scrollMarginTop: { xs: 88, md: 100 } }}
    >
      <Container maxWidth="lg">
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 8 }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'secondary.dark',
              mb: 1.5,
            }}
          >
            Como funciona
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' } }}>
            Ajudamos você a encontrar melhores caminhos para o seu plano de saúde.
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 5, md: 3 }} sx={{ position: 'relative' }}>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              position: 'absolute',
              top: 32,
              left: '12.5%',
              right: '12.5%',
              height: 2,
              bgcolor: 'divider',
            }}
          />
          {STEPS.map((step, index) => (
            <Grid item key={step.title} xs={12} sm={6} md={3}>
              <Box
                component={motion.div}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                sx={{ position: 'relative', textAlign: 'center', px: 1 }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    width: 64,
                    height: 64,
                    mx: 'auto',
                    mb: 3,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 8px 24px rgba(14, 75, 79, 0.28)',
                  }}
                >
                  {step.icon}
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: '1rem', mb: 1 }}>{step.title}</Typography>
                <Typography sx={{ fontSize: '0.88rem', color: 'text.secondary', lineHeight: 1.6 }}>
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default SolucaoSection;
